import React, { useState, useContext } from "react";
import {
  Container, Title, Desc, Caption, Resend, Button, StyledPhoneInput, Image,
  Logo, ContentContainer, InputContent, Form, Wrap, Captcha,
  StyledLogoContainer, LogoCountryCode
} from "./MobileSignInStyles";
import OtpInput from "./OtpInput";
import mountains from "src/assets/mountains.png";
import { APP_CONSTANTS } from 'src/consumer/constants'
import logo from "src/assets/logo_brand.png"
import { Link, useNavigate } from "react-router-dom";
import { isValidPhoneNumber } from 'react-phone-number-input'
import { RecaptchaVerifier, signInWithPhoneNumber, getAuth } from "firebase/auth";
import { default as app } from "src/firebase";
import { verifyLogin } from "src/consumer/services";
import { toast } from 'react-toastify';
import { LocalizationContext } from "src/consumer/context/LocalizationContext";
import { setAccessTokenExpiry } from "src/consumer/services/localstorageServices";

const MobileSignIn = (props) => {
  const navigate = useNavigate()
  const [code, setCode] = useState("");
  const [number, setNumber] = useState(props?.number || "");
  const [page, setPage] = useState('PhoneInputPage');
  const [confirmObject, setConfirm] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);

  const pageId = "mobileSignInPage";

  const { localizedDataLoading, localizedData, localizedDataError } = useContext(LocalizationContext)
  const localizedStrings = localizedData?.[pageId]

  const [verification, setVerification] = useState(localizedStrings?.get_otp || "Get OTP")

  const SendOtp = async (number) => {
    // Always get a fresh auth instance to ensure it's fully initialized
    let auth
    try {
      // Ensure app is initialized
      if (!app || !app.options) {
        console.error('Firebase app is not initialized')
        toast.error(localizedStrings?.error_sending_otp || "Firebase authentication is not initialized");
        return Promise.reject(new Error('Firebase authentication is not initialized'));
      }
      
      // Get fresh auth instance - this ensures it's fully ready
      auth = getAuth(app)
      
      // Verify auth object is valid
      if (!auth || typeof auth !== 'object') {
        console.error('Auth object is invalid:', auth)
        toast.error(localizedStrings?.error_sending_otp || "Firebase authentication is not initialized");
        return Promise.reject(new Error('Firebase authentication is not initialized'));
      }
    } catch (error) {
      console.error('Error getting auth:', error);
      toast.error(localizedStrings?.error_sending_otp || "Firebase authentication is not initialized");
      return Promise.reject(new Error('Firebase authentication is not initialized'));
    }
    
    try {
      // Ensure recaptcha container exists
      const recaptchaContainer = document.getElementById('recaptcha-container')
      if (!recaptchaContainer) {
        console.error('reCAPTCHA container not found in DOM')
        toast.error(localizedStrings?.error_sending_otp || "reCAPTCHA container not found")
        return Promise.reject(new Error('reCAPTCHA container not found'))
      }
      
      // Verify auth has necessary internal structure - check for app property
      if (!auth.app) {
        console.error('Auth object missing app property:', auth)
        toast.error(localizedStrings?.error_sending_otp || "Firebase authentication is not properly initialized")
        return Promise.reject(new Error('Firebase authentication is not properly initialized'))
      }
      
      // Small delay to ensure Firebase is fully ready (helps with timing issues)
      await new Promise(resolve => setTimeout(resolve, 100))
      
      // CRITICAL FIX: RecaptchaVerifier constructor signature for Firebase v9+ is:
      // new RecaptchaVerifier(auth, container, options) - auth is the FIRST parameter
      const CaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {});
      CaptchaVerifier.render();
      return signInWithPhoneNumber(auth, number, CaptchaVerifier)
      .then((confirmationResult) => {
        // SMS sent. Prompt user to type the code from the message, then sign the
        // user in with confirmationResult.confirm(code).
        toast.success(localizedStrings?.otp_sent || "OTP sent!")
        setConfirm(confirmationResult);
        setPage('OtpPage');
        return (confirmationResult);
        //...
      }).catch((error) => {
        // Error; SMS not sent
        console.error('Error sending OTP:', error);
        toast.error(localizedStrings?.error_sending_otp || "error sending OTP");
        return setPage('PhoneInputPage');
      });
    } catch (error) {
      console.error('Error creating RecaptchaVerifier:', error);
      toast.error(localizedStrings?.error_sending_otp || "Error initializing reCAPTCHA");
      return Promise.reject(error);
    }
  }

  // const ResendOtp =()=>{
  //   setPage('PhoneInputPage');
  // };

  const GetOtp = async (e) => {
    setVerification(localizedStrings?.loading || "Loading..")
    e.preventDefault();
    if (number.length === 0)
      toast.error("Enter a number");
    else if (isValidPhoneNumber(`+${number}`) === true)
      await SendOtp(`+${number}`);
    else
      toast.error("Phone number is not valid");
    setVerification(localizedStrings?.verify_otp || "Verify OTP")
  }

  const VerifyOtp = async () => {
    if (code === "" || code === null) {
      toast.error('OTP is Empty')
      return;
    }
    if (isVerifying) return; // Prevent double submission
    try {
      setIsVerifying(true)
      setVerification(localizedStrings?.loading || "Loading..")
      const response = await confirmObject.confirm(code);
      const firebaseIdToken = await response.user.getIdToken();
      const res = await verifyLogin(firebaseIdToken)
      localStorage.setItem('token', res.data.accessToken)
      setAccessTokenExpiry({ accessTokenExpiry: res.data.accessTokenExpiry })
      localStorage.setItem('authorities', JSON.stringify(res.data.authorities));

      if (res?.data?.info?.USER_ON_BOARD) {
        navigate('/', {})
      } else {
        const href = window.location.pathname;
        const receivedProfileData = res?.data
        if (href === '/MobileSignIn') {
          navigate('/onboarding', { state: { receivedProfileData: receivedProfileData } })
        } else if (href === '/onboarding') {
          { props?.stateChanger(receivedProfileData) }
        }
      }

    }
    catch (err) {
      toast.error('Invalid OTP! Please check again')
      setVerification("Retry")
    } finally {
      setIsVerifying(false)
    }
  }

  const renderPhone = () => {
    return (
      <>
        {!props?.signUp && <Title>{localizedStrings?.sign_in_with_mobile_number || "Sign In with Mobile Number"}</Title>}
        {!props?.signUp && <Desc>{localizedStrings?.a_one_time_password_will_be_sent_to_your_mobile_number_for_verification || "A one time password will be sent to your mobile number for verification"}</Desc>}
        <Form>
          <StyledPhoneInput
            placeholder="Mobile Number"
            enableSearch={true}
            value={number}
            onChange={value => setNumber(value)}
            searchPlaceholder="Search" style={{ fontFamily: 'heroregular' }}
            searchNotFound="No entries to show"
            country={localStorage.getItem('countryCode')?.toLowerCase() || 'in'}
            landing={props.landing}
          />
          {!props.signUp ? <Link to="/login" style={{ textDecoration: 'none' }}>
            <Caption>{localizedStrings?.sign_in_with_other_means || "Sign in with other means"}</Caption>
          </Link> : null}
          <Captcha id="recaptcha-container"></Captcha>
          <Button onClick={GetOtp}>{verification}</Button>
          <Wrap />
        </Form>
      </>
    );
  };

  const renderOTP = () => {
    return (
      <>
        {!props?.signUp && <Title>Enter the OTP</Title>}
        {!props?.signUp && <Desc>Please enter the OTP sent to your registered mobile number +{number}</Desc>}
        <OtpInput
          value={code}
          onChange={(value) => setCode(value)}
          numInputs={6}
          onComplete={VerifyOtp}
          autoFocus={true}
          disabled={isVerifying}
          darkMode={true}
          boxSize="60px"
          mobileBoxSize="52px"
          smallMobileBoxSize="48px"
          fontSize="24px"
          mobileFontSize="20px"
          smallMobileFontSize="18px"
          gap="12px"
          mobileGap="10px"
          smallMobileGap="8px"
          background="#383838"
          textColor="#FFFFFF"
          borderColor="#D9D9D9"
          focusBorderColor="#624de3"
          borderRadius="10px"
        />
        {/* <Resend onClick={ResendOtp}>Resend OTP</Resend> */}
        <Button onClick={VerifyOtp}>{verification}</Button>
      </>
    );
  };

  return (
    <>
      {
        !!props.signUp ?
          <InputContent>
            {page === 'PhoneInputPage' && renderPhone()}
            {page === 'OtpPage' && renderOTP()}
          </InputContent> :
          <Container>
            <ContentContainer>
              <Logo 
                src={APP_CONSTANTS.APP_LOGO_LINK} 
                onError={(e) => {
                  e.target.src = logo
                }}
              />
              <InputContent>
                {page === 'PhoneInputPage' && renderPhone()}
                {page === 'OtpPage' && renderOTP()}
              </InputContent>
            </ContentContainer>
            <Image src={mountains} />
          </Container>
      }
    </>
  )
}
export default MobileSignIn;


